
    import Vue from 'vue';
    import SchedulerEvent from "@/models/schedulerEvent";
    import {eventBus} from "@/services/event-bus";
    import utils from "@/services/utils";

    export default Vue.extend({
        props: ['selectedElement', 'selectedEvent', 'value', 'editable', 'userType'],
        computed: {
            selectedOpen: {
                get(): any {
                    return this.value
                },
                set(val: any) {
                    this.$emit('input', val);
                }
            }
        },
        data() {
            return {
                currentlyEditing: false,
                utils: utils
            }
        },
        methods: {
            deleteEvent(id: number) {
                this.$emit('delete-event', id);
            },
            editEvent(ev: SchedulerEvent) {
                this.$emit('edit-event', ev);
            },
            updateEvent(ev: SchedulerEvent) {
                this.$emit('update-event', ev);
            },
            goToParty(p: any) {
                return this.$router.resolve({path: `/calendar/${p.type}/${p.id}`}).href
            }
        },
        errorCaptured(err: Error, vm: Vue, info: string): boolean | void {
            eventBus.$emit('error', err.message);
        }
    });
